// import stuReport from '@/views/studyReport/stuReport'
const stuReport = () => import('@/views/studyReport/stuReport')
// import chapterReport from '@/views/studyReport/chapterReport'
const chapterReport = () => import('@/views/studyReport/chapterReport')

export default [
    {
        path: '',
        component: stuReport,
        meta: {
            title: '学情报告'
        }
    },
    {
        path: '/stureport/:sectionCode',
        component: chapterReport,
        meta: {
            title: '学情报告'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/stureport.js